import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AvatarStyleService } from '@services/avatar-style.service';
import { TuiAvatar, TuiAvatarOptions } from '@taiga-ui/kit';

@Component({
  selector: 'pxc-department-avatar',
  imports: [TuiAvatar],
  templateUrl: './department-avatar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex shrink-0 select-none' },
})
export class DepartmentAvatarComponent {
  readonly name = input.required<string>();
  readonly size = input<TuiAvatarOptions['size']>('xs');

  private readonly avatarStyleService = inject(AvatarStyleService);

  protected readonly initial = computed(() => this.name().charAt(0).toLocaleUpperCase() || '?');
  protected readonly avatarStyle = computed(() => this.avatarStyleService.getAvatarStyle(this.name()));
}
